<template>
  <div>
    <h3>Have you had diabetes during pregnancy?</h3>
    <v-form-group class="card-selector" :validator="$v.pregnancyDiabetStatus">
      <b-form-radio v-model="survey.pregnancyDiabetStatus" name="pregnancy" :value=pregnancyDiabetType.Yes>Yes</b-form-radio>
      <b-form-radio v-model="survey.pregnancyDiabetStatus" name="pregnancy" :value=pregnancyDiabetType.No>No</b-form-radio>
    </v-form-group>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { required } from "vuelidate/lib/validators";

  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');

  import pregnancyDiabetType from "enums/pregnancy-diabet-type";

  export default {
    mixins: [formMixin],
    data() {
      return {
        pregnancyDiabetType: pregnancyDiabetType,
      };
    },

    validations: {
      pregnancyDiabetStatus: {
        required
      }
    },

    computed: {
      ...mapState(["survey"]),

      pregnancyDiabetStatus() { return this.survey.pregnancyDiabetStatus }
    },

    methods: {
      onSubmit() {

      }
    }
  };
</script>